<template>
    <section class="other-news">
        <news-heading :subtitle="true" id="external" :noMargin="true">Other News Companies</news-heading>
        <div v-masonry transition-duration="0.3s" item-selector=".item">
            <news-external v-masonry-tile v-for="post in allPosts" :post="post" :key="post.id"></news-external>
        </div>
        <div v-if="posts.length" class="news-button-container">
            <button @click="nextPage" class="news-button" v-if="!finished">
                Show More
                <loading-icon v-if="loading"></loading-icon>
            </button>
        </div>
    </section>
</template>

<script>
	import NewsHeading from "./news-heading.vue";
	import axios from "axios";
	import {stripInformation} from "../shared/stripInformation";
	import LoadingIcon from "./loading-icon.vue";
	import NewsExternal from "./news-external.vue";

    export default {
    	components: {
			NewsHeading,
			LoadingIcon,
			NewsExternal
        },
        data () {
    	    return {
    	    	loading: false,
				postPagesData: [],
				currentPage: 0,
				finished: false,
            }
        },
        created () {
			this.openPage(1);
        },
        methods: {
			openPage (page, amount = 6) {
				this.currentPage = page;
				this.loading = true;
				axios.get("/wp-json/news/v1/posts", {
					params: {
						page: page,
						amount
					}
				})
					.then(({data}) => {
						if (data === null) {
							this.finished = true;
						} else {
							this.finished = false;
							this.postPagesData.push(data);
						}
					})
					.then(() => {
						this.loading = false;
					})
			},
			nextPage () {
				this.openPage(++this.currentPage);
			},
			posts (posts) {
				let data = posts;
				if (data && data.length) {
					return stripInformation(data);
				} else {
					return [];
				}
			},
        },
        computed: {
			postPages () {
				return this.postPagesData.map(posts => this.posts(posts));
			},
			allPosts () {
				return this.postPages.reduce((accumulator, current) => {
					accumulator.push(...current);
					return accumulator;
				}, []);
			}
        }
    }
</script>

<style>
    .other-news {
        width: 100%;
        margin-bottom: 2rem;
        position: relative;
    }
    .news-button-container {
        display: flex;
        padding: 2rem 1rem;
        width: 100%;
    }

    .news-button {
        background-color: #577f40;
        box-shadow: 1px 1px 2px 2px rgba(0,0,0,.3);
        color: white;
        width: 100%;
        padding: 1rem .5rem;
        font-size: 1.5rem;
    }
</style>


// WEBPACK FOOTER //
// other-news.vue?9088dd40